<script>
  import { createEventDispatcher } from 'svelte'
  import filterClasses, { updateClasses, cssPrefix } from '../helper-classes.js'
  import Close from '../Close/'

  export let id = null

  export let label = ''
  export let status = null
  export let inverted = false
  export let bold = false
  export let close = false
  export let clickable = false
  export let transparent = false
  export let variant = ''

  export let style = null
  export let helperClass = null
  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  let classes = [`${cssPrefix}badge`]
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  if (![null, 'primary', 'success', 'info', 'warning', 'error'].includes(status)) {
    console.debug(`[DS:Badge] invalid status ${status}`)
  }

  if (variant === 'tag') classes.push('variant-tag')
  if (inverted) classes.push('is-inverted')
  if (bold) classes.push('is-bold')
  if (transparent) classes.push('is-transparent')

  const dispatch = createEventDispatcher()

  $: classes = updateClasses(classes, status, 'is-status-' + status, /^is-status/)
</script>

{#if clickable}
  <button class={classes.join(' ')} {style} {id}>
    <span class={`${cssPrefix}-badge-label`}>{label}</span>
  </button>
{:else}
  <div class={classes.join(' ')} {style} {id}>
    <span class={`${cssPrefix}-badge-label`}>{label}</span>

    {#if close}
      <Close
        on:close={e => {
          e.preventDefault()
          dispatch('close')
        }}
        style="position:sticky"
      />
    {/if}
  </div>
{/if}
